/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * Canned data so the whole UI can be built and design-reviewed with no backend.
 * Replaced by real API calls in the mock→API swap (design build step 6).
 * Copy is drone-ops domain — NOT the old "warehouse / inventory" placeholder text.
 */

/** Domain-correct starter prompts for the empty state. */
export const SUGGESTED_PROMPTS = [
  "What did I upload this week?",
  "Find my largest files",
  "Which files have I shared publicly?",
  "Summarise what's in my Drive",
];

/**
 * Fake conversation history for the HistoryModal (grouped by date client-side).
 * `type` drives the Pulses / Guides filter chips: "pulse" | "guide" | undefined.
 */
export const MOCK_HISTORY = [
  { assistantChatId: "c1", title: "Missions with audits due this week", type: "pulse", updatedAt: Date.parse("2026-07-11T09:00:00Z") },
  { assistantChatId: "c2", title: "Order fulfillment priorities and actions", updatedAt: Date.parse("2026-07-11T06:00:00Z") },
  { assistantChatId: "c3", title: "Drone VX-2 #12 battery health", type: "pulse", updatedAt: Date.parse("2026-07-09T14:00:00Z") },
  { assistantChatId: "c4", title: "Prepare fleet for monsoon operations", type: "guide", updatedAt: Date.parse("2026-06-28T10:00:00Z") },
  { assistantChatId: "c5", title: "Weekly project change digest", updatedAt: Date.parse("2026-06-20T10:00:00Z") },
  { assistantChatId: "c6", title: "Setting up your own API keys", type: "guide", updatedAt: Date.parse("2026-05-30T10:00:00Z") },
];

/**
 * A scripted assistant reply used by the mock streamer: an ordered list of stream
 * events (steps + token chunks) that imitate a grounded, agentic answer.
 * @param {string} userMessage
 * @returns {import("./types").StreamEvent[]}
 */
export const scriptReply = (userMessage) => {
  const chunks = [
    "You have **2 missions** with audits due this week.\n\n",
    "**1. Mission 418 — post-flight audit** — due tomorrow, ",
    "flagged *high priority* (payload anomaly logged on the last sortie).\n\n",
    "**2. Mission 402 — compliance audit** — due Friday, routine.\n\n",
    "Want me to draft the report for Mission 418 first?",
  ];
  return [
    { type: "step", label: "Searched missions", status: "done" },
    { type: "step", label: "Checked audit schedule", status: "done" },
    ...chunks.map((text) => ({ type: "token", text })),
    { type: "title", title: "Missions with audits due this week" },
    { type: "done" },
  ];
};
